/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Fact_ConditionInputs */

const cs_public_site_fact_condition = /** @type {(inputs: Public_Site_Fact_ConditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stav`)
};

const en_public_site_fact_condition = /** @type {(inputs: Public_Site_Fact_ConditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condition`)
};

/**
* | output |
* | --- |
* | "Condition" |
*
* @param {Public_Site_Fact_ConditionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_fact_condition = /** @type {((inputs?: Public_Site_Fact_ConditionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Fact_ConditionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_fact_condition(inputs)
	return cs_public_site_fact_condition(inputs)
});